export default __webpack_public_path__ + "static/media/icon_down.f3e4d5ed.svg";